import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChildren } from '@angular/core';
import { DataSheetIP, DatasheetNumbers, DataSheetSubOrderIP, SalesOrder, SaveStatusObj, SubSalesOrder, UserType } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { of } from 'rxjs';

@Component({
  selector: 'copy-data-sheet-suborder',
  templateUrl: './copy-data-sheet-suborder.component.html',
  styleUrls: ['./copy-data-sheet-suborder.component.css']
})
export class CopyDataSheetSuborderComponent implements OnChanges, OnInit {

  @Input() DSSubOrderList:Array<any>;
  @Input() soLock: boolean;
  @Input() loadCounter:SalesOrder;
  @Input() subOrderObj: SubSalesOrder;
  @Output() createNewDatasheetSubOrder: EventEmitter<any> = new EventEmitter();
  inputDisableMessage:string = '';

  datasheetlist:Array<any>;
  disableForm: boolean=false;
  accessLevel: Array<UserType> = [];


  selectedSubNumId:string;
  selectedCopySubNumId:string = "-1";
  constructor(public _dataService: DataService
    //public dialogRef: MatDialogRef<AddSuborderPopup>,
    //@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(){
  }
  ngOnChanges(){
    this.disableForm=true;
    this.accessLevel.push(UserType.SUPER_ADMIN, UserType.PROJECT_MANAGEMENT, UserType.HOD_PROJECT_MANAGEMENT); // ONLY these users can ADD Datasheets in SSO Level

    if (this.issoLockObtained == false){
      this.inputDisableMessage= "You can't Edit, Sale Order Lock NOT obtained";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else{
      this.disableForm =false
    }
   
  }
   get issoLockObtained(): boolean{
    return this.soLock;
  }

  addNewDataSheetSSO(){
    if(this.selectedSubNumId){
      this.createNewDatasheetSubOrder.emit({"selSubNumId":this.selectedSubNumId,"copySubNumId":this.subOrderObj.subOrderNoId});
    }
}

//  createNewDatasheetSubOrderEvent(_evnt:any){
//     //{"selSubNumId":this.selectedSubNumId,"copySubNumId":this.selectedCopySubNumId}
//     this.addNewDataSheetSubOrder(_evnt.selSubNumId);
//   }
//   addNewDataSheetSubOrder(_selectedSubSoNumId:string) {
//       this._dataService.openLoader();
//       if (_selectedSubSoNumId) {
//         let _tmpDS = this.loadCounter.dataSheetIP.filter((opt) => opt.dataSheetId == _selectedSubSoNumId)[0];
//         let _tmpSubOrderClone: DataSheetSubOrderIP = DataSheetSubOrderIP.getObj(_tmpDS);
//         _tmpSubOrderClone.dataSheetId = _selectedSubSoNumId;
//         this.subOrderObj.addNewDSSubSo(_tmpSubOrderClone);
//       }
//       this._dataService.closeLoader();
  
//     }

}

